import { useState } from 'react';
import { supabase } from '../lib/supabase';

const NAVY = '#1B2A4A';
const GOLD = '#B59A6A';

const T = {
  en: {
    teamLogin: 'Team Member', clientLogin: 'Client',
    teamDesc: 'Internal platform access', clientDesc: 'View your matter & documents',
    email: 'Email Address', password: 'Password',
    signin: 'Sign In', signing: 'Signing in…',
    wrongCreds: 'Incorrect email or password. Please try again.',
    notTeam: 'This account is not registered as a team member. Please select Client.',
    notClient: 'This account is a team member account. Please select Team Member.',
    lang: 'Türkçe', tagline: 'Legal Services · Since 1988',
    footer: 'For access, contact your Koluman Law representative.',
    selectType: 'How are you logging in?', back: 'Back',
  },
  tr: {
    teamLogin: 'Ekip Üyesi', clientLogin: 'Müvekkil',
    teamDesc: 'Dahili platform erişimi', clientDesc: 'Dosyanızı ve belgelerinizi görüntüleyin',
    email: 'E-posta Adresi', password: 'Şifre',
    signin: 'Giriş Yap', signing: 'Giriş yapılıyor…',
    wrongCreds: 'E-posta veya şifre hatalı. Lütfen tekrar deneyin.',
    notTeam: 'Bu hesap ekip üyesi olarak kayıtlı değil. Lütfen Müvekkil seçeneğini seçin.',
    notClient: 'Bu hesap bir ekip üyesi hesabıdır. Lütfen Ekip Üyesi seçeneğini seçin.',
    lang: 'English', tagline: "Hukuk Hizmetleri · 1988'den Beri",
    footer: 'Erişim için Koluman Law temsilcinizle iletişime geçin.',
    selectType: 'Nasıl giriş yapmak istiyorsunuz?', back: 'Geri',
  },
};

export default function LoginScreen() {
  const [lang,     setLang]     = useState('en');
  const [type,     setType]     = useState(null);
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const t = T[lang];

  const reset = () => { setType(null); setError(''); setEmail(''); setPassword(''); };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    const { error: authErr } = await supabase.auth.signInWithPassword({ email, password });
    if (authErr) { setError(t.wrongCreds); setLoading(false); return; }
    const { data: member } = await supabase.from('team').select('id').eq('email', email).single();
    const isTeamMember = !!member;
    if (type === 'team' && !isTeamMember) {
      await supabase.auth.signOut(); setError(t.notTeam); setLoading(false); return;
    }
    if (type === 'client' && isTeamMember) {
      await supabase.auth.signOut(); setError(t.notClient); setLoading(false); return;
    }
    // Success — auth state change handles routing
  };

  return (
    <div style={{ minHeight:'100vh', background:'#0F1924', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Segoe UI', system-ui, sans-serif", padding:20, position:'relative', overflow:'hidden' }}>
      {/* Rings */}
      <div style={{ position:'fixed', inset:0, pointerEvents:'none' }}>
        {[...Array(7)].map((_, i) => (
          <div key={i} style={{ position:'absolute', width:350+i*110, height:350+i*110, border:`1px solid ${GOLD}${i<3?'18':'0A'}`, borderRadius:'50%', top:'50%', left:'50%', transform:'translate(-50%,-50%)' }} />
        ))}
        <div style={{ position:'absolute', top:0, left:0, right:0, height:2, background:`linear-gradient(90deg, transparent, ${GOLD}55, transparent)` }} />
        <div style={{ position:'absolute', bottom:0, left:0, right:0, height:2, background:`linear-gradient(90deg, transparent, ${GOLD}55, transparent)` }} />
      </div>

      {/* Language */}
      <button onClick={() => { setLang(l => l==='en'?'tr':'en'); setError(''); }} style={{ position:'fixed', top:24, right:24, background:'none', border:`1px solid ${GOLD}55`, color:GOLD, borderRadius:6, padding:'6px 16px', fontSize:12, cursor:'pointer', fontFamily:'inherit' }}>{t.lang}</button>

      {/* Card */}
      <div style={{ background:'#FFF', borderRadius:18, width:'100%', maxWidth:460, boxShadow:'0 40px 100px rgba(0,0,0,0.55)', overflow:'hidden' }}>
        <div style={{ height:4, background:`linear-gradient(90deg, ${NAVY}, ${GOLD}, ${NAVY})` }} />
        <div style={{ padding:'40px 40px 32px' }}>

          {/* Logo */}
          <div style={{ textAlign:'center', marginBottom:32 }}>
            <div style={{ fontFamily:'Georgia,serif', fontSize:36, fontWeight:700, color:NAVY }}>Koluman<span style={{ color:GOLD }}>Law</span></div>
            <div style={{ fontSize:11, color:'#AAA', letterSpacing:2, marginTop:8, textTransform:'uppercase' }}>{t.tagline}</div>
            <div style={{ width:48, height:1, background:GOLD, margin:'14px auto 0' }} />
          </div>

          {/* Step 1: Choose type */}
          {!type && (
            <div>
              <div style={{ fontSize:12, color:'#999', textAlign:'center', marginBottom:20, letterSpacing:0.5 }}>{t.selectType}</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                {[
                  { key:'team',   label:t.teamLogin,   desc:t.teamDesc,   icon:'⚖' },
                  { key:'client', label:t.clientLogin, desc:t.clientDesc, icon:'👤' },
                ].map(opt => (
                  <button key={opt.key} onClick={() => setType(opt.key)} style={{ border:`1.5px solid #E5E0D8`, borderRadius:12, padding:'22px 16px', background:'#FAFAF8', cursor:'pointer', fontFamily:'inherit', textAlign:'center' }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor=GOLD; e.currentTarget.style.background=GOLD+'0A'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor='#E5E0D8'; e.currentTarget.style.background='#FAFAF8'; }}>
                    <div style={{ fontSize:30, marginBottom:10 }}>{opt.icon}</div>
                    <div style={{ fontSize:14, fontWeight:700, color:NAVY, marginBottom:5 }}>{opt.label}</div>
                    <div style={{ fontSize:11, color:'#AAA', lineHeight:1.5 }}>{opt.desc}</div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Step 2: Login form */}
          {type && (
            <div>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
                <div style={{ background:NAVY, color:GOLD, borderRadius:20, padding:'4px 16px', fontSize:12, fontWeight:700 }}>
                  {type==='team' ? t.teamLogin : t.clientLogin}
                </div>
                <button onClick={reset} style={{ background:'none', border:'none', color:'#AAA', cursor:'pointer', fontSize:12, fontFamily:'inherit' }}>← {t.back}</button>
              </div>

              <form onSubmit={handleLogin} style={{ display:'flex', flexDirection:'column', gap:18 }}>
                <div>
                  <label style={{ fontSize:11, fontWeight:700, color:NAVY, textTransform:'uppercase', letterSpacing:0.8, display:'block', marginBottom:7 }}>{t.email}</label>
                  <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required autoFocus
                    style={{ width:'100%', padding:'12px 14px', borderRadius:8, boxSizing:'border-box', border:'1px solid #E0DADA', fontSize:14, background:'#FAFAF8', fontFamily:'inherit', outline:'none' }} />
                </div>
                <div>
                  <label style={{ fontSize:11, fontWeight:700, color:NAVY, textTransform:'uppercase', letterSpacing:0.8, display:'block', marginBottom:7 }}>{t.password}</label>
                  <input type="password" value={password} onChange={e=>setPassword(e.target.value)} required
                    style={{ width:'100%', padding:'12px 14px', borderRadius:8, boxSizing:'border-box', border:'1px solid #E0DADA', fontSize:14, background:'#FAFAF8', fontFamily:'inherit', outline:'none' }} />
                </div>
                {error && <div style={{ background:'#FDF0EE', border:'1px solid #F5C0B8', borderRadius:7, padding:'10px 14px', fontSize:13, color:'#C0392B', lineHeight:1.5 }}>{error}</div>}
                <button type="submit" disabled={loading} style={{ marginTop:4, background:loading?'#8899BB':NAVY, color:GOLD, border:'none', borderRadius:8, padding:'14px', fontSize:14, fontWeight:700, cursor:loading?'not-allowed':'pointer', fontFamily:'inherit' }}>
                  {loading ? t.signing : t.signin}
                </button>
              </form>
            </div>
          )}
        </div>
        <div style={{ background:'#F7F5F0', borderTop:'1px solid #EDE9E3', padding:'14px 40px', fontSize:11, color:'#BBB', textAlign:'center', lineHeight:1.7 }}>{t.footer}</div>
      </div>
    </div>
  );
}
